module.exports = __webpack_public_path__ + "static/media/ic_day_check_white.aa297b96.svg";